// extracted by mini-css-extract-plugin
export default {"container":"PC-z","leftColumn":"QC-z","rightColumn":"RC-z","item":"SC-z"};